import axios from "axios";
import toastMessage from "./toastMessage";

const AwsAxios = axios.create({});

AwsAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    // console.log(token, " = token in AwsAxios:Config");
    if (token) {
      // config.headers["Content-Type"] = "application/json"
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    console.log("🚀 ~ error:sadsadsad", error);
    return Promise.reject(error);
  }
);

AwsAxios.interceptors.response.use(
  (response) => {
    console.log("🚀 ~ response:", response);
    // handle success
    return response;
  },
  (error) => {
    console.log("🚀 ~ error:", error);
    if (error.response?.status === 401 || error.response?.status === 403) {
      // network error
      console.log("error", error);
      toastMessage("Your Session has been expired", "info");
      window.localStorage.clear();
      window.location.href = "/signin";
    } else {
      // localStorage.removeItem("user")
      console.log(error.response, " error.response");
    }

    return Promise.reject(error);
  }
);

export default AwsAxios;
